import CheckIcon from "@mui/icons-material/Check";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import HtmlFromLangFile from "../../01-atoms/HtmlFromLangFile/HtmlFromLangFile";
import { NWONKeyFactsProps } from "./NWONKeyFactsInterfaces";
import { useNWONKeyFacts } from "./NWONKeyFactsStyles";

export const NWONKeyFacts = (props: NWONKeyFactsProps): JSX.Element => {
  const { classes } = useNWONKeyFacts();

  return (
    <List>
      {props.facts.map((fact, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ListItem key={index}>
          <ListItemIcon className={classes.icon}>
            <CheckIcon />
          </ListItemIcon>

          <ListItemText>
            {typeof fact === "string" ? (
              <Typography>
                <HtmlFromLangFile contentContainingHtml={fact} />
              </Typography>
            ) : (
              fact
            )}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};
